<template>
  <div>
    <Header v-if="$route.path !== '/retail'"/>
    <router-view />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/header/index.vue';
import Footer from '@/components/footer/index.vue';

export default {
  components: {
    Footer,
    Header
  }
}
</script>

<style lang="scss">
@import "assets/scss/main";
</style>
